import notificationSound from './noti.mp3';

let audioInstance: HTMLAudioElement | null = null;

export const playNotificationSound = () => {
  try {
    if (!audioInstance) {
      audioInstance = new Audio(notificationSound);
      audioInstance.volume = 1;
    }
    audioInstance.currentTime = 0;
    audioInstance.play().catch((err) => {
      console.warn('Sound blocked by browser:', err);
    });
  } catch (err) {
    console.warn('Could not play notification sound:', err);
  }
};